import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { MaintenanceModule } from '../maintenance/maintenance.module';

// Inventory Components
import { InventoryComponent } from './inventory/inventory.component';
import { InputsComponent } from './inputs/inputs.component';
import { InputsDetailsComponent } from './inputs/inputs-details/inputs-details.component';
import { OutputsComponent } from './outputs/outputs.component';
import { OutputsDetailsComponent } from './outputs/outputs-details/outputs-details.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { DetailsInventoryTransferComponent } from "./inventory-transfer/details-inventory-transfer/details-inventory-transfer.component";
import { DetailsPurchaseOrderComponent } from './purchase-order/details-purchase-order/details-purchase-order.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { InventoryTransferComponent } from './inventory-transfer/inventory-transfer.component';

const InventoryComponents = [
  InventoryComponent,
  InputsComponent,
  InputsDetailsComponent,
  OutputsComponent,
  OutputsDetailsComponent,
  PurchaseOrderComponent,
  DetailsPurchaseOrderComponent,
  WarehouseComponent,
  InventoryTransferComponent,
  DetailsInventoryTransferComponent
];

@NgModule({
  declarations: InventoryComponents,
  imports: [SharedModule, MaintenanceModule],
  exports: InventoryComponents
})
export class InventoryModule { }
